<!-- Alert -->

<template>
  <div class="alerta">
    <b-modal 
      v-model="snackbar"
      :title="titulo"
      ok-only
      no-close-on-backdrop no-close-on-esc 
      centered
    >
    <template v-slot:modal-header="{ close }">
        <b-button @click="close()">Close Modal</b-button>
        <h5>Header</h5>
    </template>

    {{ mensaje }} <br><b>Hola como estamos</b> ... Bien
    
    <template v-slot:modal-footer="{ ok, cancel, hide }">
      <p>Footer</p>
      <b-button success @click="ok()">OK</b-button>
      <b-button @click="cancelar()">Cancel</b-button>
      <b-button @click="hide('hide')">Hide</b-button>
    </template>    
    </b-modal>    
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: 'alerta',

      snackbar: false,
      titulo: "",
      mensaje: "",
    
      tipos: [
        { name: "success", icon: "mdi-check-circle-outline",  bind: { color: "green", top: true } },
        { name: "info", icon: "mdi-information-outline", bind: { color: "orange", top: true } },
        { name: "error", icon: "mdi-alert-circle-outline", bind: { color: "red", top: true } },
        { name: "confirm", icon: "mdi-help-circle-outline", bind: { color: "cyan darken-2", top: true } },
        { name: "default", icon: "mdi-alert-decagram-outline", bind: { color: "cyan darken-2", top: true } },
      ],
      resolve: null,
      reject: null
    };
  },

  methods: {
    // muestro notificación
    open(arg, timeout = null) {
      console.log('** alerta.open',arg);
      //arg -> mensaje,titulo...

      if (!arg.mensaje) return;
      this.mensaje = arg.mensaje;

      this.titulo = (!arg.titulo ? 'ATENCIÓN' : arg.titulo);

      //botones -> btn:

      // temporizador o indifinido
      timeout ? setTimeout(this.close, timeout) : 0;

      this.snackbar = true;
    },

    // acepto promesa
    agree() {
      console.log("** alerta.agree");
      this.resolve(true);
      this.snackbar = false;
    },

    // NO acepto promesa
    cancelar() {
      console.log("** alerta.cancel");
      //this.resolve(false);
      this.snackbar = false;
      //this.$bvModal.hide()
    },

    // cierro notificación
    close() {
      console.log("** alerta.close");
      this.snackbar = false;
    }
  }
};
</script>
